enum FetchStatus {
  fetching = "fetching",
  paused = "paused",
  idle = "idle"
}

export default FetchStatus;
